import React, { useEffect, useState } from 'react';
import { Joyride, STATUS } from 'react-joyride';
import { useAuth } from '@/contexts/AuthContext';

const TOUR_STEPS = [
  {
    target: 'body',
    content: (
      <div className="text-left">
        <h3 className="font-bold text-lg mb-2">Vítejte v GreenCAD!</h3>
        <p className="text-sm">Tato krátká prohlídka vás provede klíčovými funkcemi za 60 vteřin.
          Můžete ji kdykoli ukončit tlačítkem <strong>Přeskočit</strong>.</p>
        <p className="text-xs text-slate-500 mt-3">⏱️ Demo účet vyprší za 60 minut.</p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-testid="project-list"], [data-testid="projects-grid"], main',
    content: 'Toto jsou vaše demo projekty. Připravili jsme je s reálnými daty pro typ firmy, který jste vybrali při registraci.',
    placement: 'auto',
  },
  {
    target: '[data-testid^="project-card"]:first-of-type, [data-testid="project-card-0"]',
    content: 'Klikněte na libovolný projekt pro otevření v editoru. Můžete prozkoumat půdorys, symboly i kompletní dokumentaci.',
    placement: 'right',
  },
  {
    target: 'a[href*="/symbols"], [data-testid="version-symbol-gallery-link"]',
    content: 'V galerii symbolů najdete přes 120 ikon CAD prvků — od zásuvek po Loxone komponenty. Můžete je exportovat jako PNG nebo CSV.',
    placement: 'bottom',
  },
  {
    target: 'body',
    content: (
      <div className="text-left">
        <h3 className="font-bold text-base mb-2">Užijte si demo! 🎉</h3>
        <ul className="text-sm space-y-1 list-disc pl-5">
          <li>Klikejte, kreslete, exportujte do PDF/DXF</li>
          <li>Vše je sandbox — nic se neuloží trvale</li>
          <li>Líbí se vám to? Napište na <strong>info@solar-green.cz</strong></li>
        </ul>
      </div>
    ),
    placement: 'center',
  },
];

const STORAGE_KEY = 'greencad_demo_tour_completed';

export default function DemoTour() {
  const { user } = useAuth();
  const [run, setRun] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Only start the tour on the projects dashboard; never on /koupit, /editor, etc.
    if (typeof window !== 'undefined' && window.location?.pathname !== '/projekty') return;
    try {
      const completed = localStorage.getItem(STORAGE_KEY) === '1';
      if (user.is_demo_user && !completed) {
        const t = setTimeout(() => setRun(true), 800);
        return () => clearTimeout(t);
      }
    } catch { /* ignore */ }
  }, [user]);

  const handleCallback = (data) => {
    const { status } = data;
    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      localStorage.setItem(STORAGE_KEY, '1');
      setRun(false);
    }
  };

  if (!run) return null;

  return (
    <Joyride
      steps={TOUR_STEPS}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={{
        back: 'Zpět',
        close: 'Zavřít',
        last: 'Hotovo',
        next: 'Další',
        skip: 'Přeskočit',
      }}
      styles={{
        options: {
          primaryColor: '#10b981',
          backgroundColor: '#0f172a',
          textColor: '#f1f5f9',
          arrowColor: '#0f172a',
          overlayColor: 'rgba(0, 0, 0, 0.7)',
          zIndex: 10000,
        },
        tooltip: {
          borderRadius: 12,
          border: '1px solid rgba(16,185,129,0.3)',
        },
        buttonNext: {
          backgroundColor: '#10b981',
          borderRadius: 8,
        },
        buttonSkip: {
          color: '#94a3b8',
        },
      }}
    />
  );
}
